import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";

const requestSchema = yup.object({
  patientId: yup.number().required(),
  message: yup.string().required(),
  isFirstMessage: yup.boolean().notRequired(),
  conversationId: yup.number().notRequired(),
});

export const useSendPatientSmsMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto) => {
      const req = requestSchema.validateSync(dto, { strict: true });
      return http.post(HTTP_ENDPOINTS.patient.sendSms(), {
        patient_id: req.patientId,
        reply: req.message,
        mode: req.isFirstMessage ? "add" : "edit",
        id: req.isFirstMessage ? 0 : req.conversationId,
      });
    },
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.patient.sms],
      });
      options.onSuccess?.(...args);
    },
  });
};
